import React from 'react';
import { dateFormatter } from 'misc/cellFormatters';
import { JOB_DETAIL } from 'misc/constants';
import { deadlineComparator, getRowHeight } from 'misc/utils';
import {
  LinkFieldCellRenderer,
  ClientFieldCellRenderer,
  AssignmentFieldCellRenderer,
  ScheduleStatusCellRenderer
} from 'misc/cellRenderers';
import ListTable from 'components/core/ListTable';
import PureRenderComponent from 'components/core/PureRenderComponent';


class JobToTraListTable extends PureRenderComponent {
  constructor(props) {
    super(props);
    this.state = {
      columnDefs: [
        {
          headerName: 'No.',
          field: 'number',
          cellClass: 'ag-jobNumber',
          pinned: 'left',
          width: 140,
          cellRendererFramework: LinkFieldCellRenderer,
          cellRendererParams: {
            handleTabOpen: this.props.handleTabOpen,
            tab: JOB_DETAIL,
          },
        },
        {
          headerName: 'Client',
          field: 'client.name',
          comparator: (valueA, valueB, nodeA, nodeB) => (
            deadlineComparator(nodeA.data, nodeB.data)
          ),
          cellRendererFramework: ClientFieldCellRenderer,
          width: 150,
        },
        {
          headerName: 'Subject',
          field: 'subject',
          width: 250,
        },
        {
          headerName: 'Memo',
          field: 'memo',
          width: 250,
        },
        {
          headerName: 'Service',
          field: 'service.name',
          width: 80,
        },
        {
          headerName: 'Lv',
          field: 'level',
          width: 40,
        },
        {
          headerName: 'ToTra',
          colId: 'totra',
          field: 'totra.assignee.name',
          width: 85,
          comparator: (valueA, valueB, nodeA, nodeB) => (
            deadlineComparator(nodeA.data.totra, nodeB.data.totra)
          ),
          cellRendererFramework: AssignmentFieldCellRenderer,
          cellRendererParams: { roleKey: 'totra' },
        },
        {
          headerName: 'Tra',
          field: 'translator.assignee.name',
          width: 85,
          comparator: (valueA, valueB, nodeA, nodeB) => (
            deadlineComparator(nodeA.data.translator, nodeB.data.translator)
          ),
          cellRendererFramework: AssignmentFieldCellRenderer,
          cellRendererParams: { roleKey: 'translator' },
        },
        {
          headerName: 'Edi',
          field: 'editor.assignee.name',
          width: 85,
          comparator: (valueA, valueB, nodeA, nodeB) => (
            deadlineComparator(nodeA.data.editor, nodeB.data.editor)
          ),
          cellRendererFramework: AssignmentFieldCellRenderer,
          cellRendererParams: { roleKey: 'editor' },
        },
        {
          headerName: 'Che',
          field: 'checker.assignee.name',
          width: 85,
          comparator: (valueA, valueB, nodeA, nodeB) => (
            deadlineComparator(nodeA.data.checker, nodeB.data.checker)
          ),
          cellRendererFramework: AssignmentFieldCellRenderer,
          cellRendererParams: { roleKey: 'checker' },
        },
        {
          headerName: 'FE1',
          field: 'finalEditor.assignee.name',
          width: 85,
          comparator: (valueA, valueB, nodeA, nodeB) => (
            deadlineComparator(nodeA.data.finalEditor, nodeB.data.finalEditor)
          ),
          cellRendererFramework: AssignmentFieldCellRenderer,
          cellRendererParams: { roleKey: 'finalEditor' },
        },
        {
          headerName: 'FE2',
          field: 'secondFinalEditor.assignee.name',
          width: 85,
          comparator: (valueA, valueB, nodeA, nodeB) => (
            deadlineComparator(nodeA.data.secondFinalEditor, nodeB.data.secondFinalEditor)
          ),
          cellRendererFramework: AssignmentFieldCellRenderer,
          cellRendererParams: { roleKey: 'secondFinalEditor' },
        },
        {
          headerName: 'DTP1',
          field: 'dtp.assignee.name',
          width: 85,
          comparator: (valueA, valueB, nodeA, nodeB) => (
            deadlineComparator(nodeA.data.dtp, nodeB.data.dtp)
          ),
          cellRendererFramework: AssignmentFieldCellRenderer,
          cellRendererParams: { roleKey: 'dtp' },
        },
        {
          headerName: 'DTP2',
          field: 'secondDtp.assignee.name',
          width: 85,
          comparator: (valueA, valueB, nodeA, nodeB) => (
            deadlineComparator(nodeA.data.secondDtp, nodeB.data.secondDtp)
          ),
          cellRendererFramework: AssignmentFieldCellRenderer,
          cellRendererParams: { roleKey: 'secondDtp' },
        },
        {
          headerName: 'Receive Date',
          field: 'receiveDate',
          valueFormatter: dateFormatter,
          width: 140,
        },
        {
          headerName: 'Target',
          field: 'targetCount',
          width: 90,
          filter: 'agNumberColumnFilter',
        },
        {
          headerName: 'AE',
          field: 'ae.name',
          width: 90,
        },
        {
          headerName: 'Coordinator',
          field: 'coordinator.name',
          width: 120,
        },
        {
          headerName: 'Status',
          field: 'status',
          width: 140,
          pinned: 'right',
          cellRendererFramework: ScheduleStatusCellRenderer
        }
      ]
    }
  }

  render() {
    return (
      <ListTable
        wrapperHeight="83vh"
        rowClass="ag-double-row"
        columnDefs={this.state.columnDefs}
        rowData={this.props.jobs}
        getRowHeight={getRowHeight} />
    );
  }
}

export default JobToTraListTable;
